import styled from '@emotion/styled'
import React, { useState } from 'react'
import { Box } from '@mui/system'
import { Alert, Autocomplete, Button, Chip, Snackbar, TextField } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import ResearchTable from '../../components/tables/100/ReseachTable';
import useAuth from '../../hooks/useAuth';
const Research=styled(Box)(({theme})=>({
  display:'flex',
  flexDirection:'column',
}))
const ToolBar=styled(Box)(({theme})=>({
  background:theme.palette.background.default,
  width:'100%',
  display:'flex',
  justifyContent:'flex-end',
  borderBottom: `1px solid ${theme.palette.background.paper}`,
  padding:'10px',
  gap:'15px'
}))
const Search=styled(Autocomplete)(({theme})=>({
  width: '300px',
  margin: 0,
  padding: 0,

}))
const filterOptions = ['Active', 'Pending', 'Expired'];

export default function Researches() {
 const navigate=useNavigate();
 const {state}=useLocation();
  const [search,setSearch]=useState('');
  const [filter, setFilter] = React.useState(['Active', 'Pending', 'Expired']);
  const {user}=useAuth()
  const RequestResearch=()=>{
 navigate('/researches/new_researches')
}
const [open,setOpen]=useState(state===null?false:true)

  return (
    <Research>
     <ToolBar>
    {user.roles.includes(105) &&
        <Button variant="contained"
        size="small"
        sx={{
          bgcolor:'secondary.main',
          fontWeight: 400,
          color:'#fff',
          "&:hover":{
          bgcolor:'secondary.hover',
          }
          }}
        onClick={RequestResearch}
        >Request Research</Button>}
      </ToolBar>
      <ResearchTable id={state!==null?state.id:false}/>
      <Snackbar open={open} autoHideDuration={6000} onClose={()=>setOpen(false)}>
            <Alert severity="success">{state?.message} </Alert>
        </Snackbar>
    </Research>
  )
}
